import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import {
  BillingInterval,
  Cart,
  CartItem,
  Currency,
} from "@version2/domain-package";

interface CartState {
  currency: Currency;
  billingInterval: BillingInterval;
  cart: any;
}

const initialState: CartState = {
  currency: Currency.defaultValue,
  billingInterval: BillingInterval.defaultValue,
  cart: new Cart({ items: [] }).toJson(false),
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCurrency: (state, action: PayloadAction<Currency>) => {
      state.currency = action.payload;
    },
    setBillingInterval: (state, action: PayloadAction<BillingInterval>) => {
      state.billingInterval = action.payload;
    },
    setCartItems: (state, action: PayloadAction<CartItem[]>) => {
      const cart = Cart.fromJson(state.cart);
      cart.setItems(action.payload);
      state.cart = cart.toJson(false);
    },
    addCartItem: (state, action: PayloadAction<CartItem>) => {
      const cart = Cart.fromJson(state.cart);
      cart.addItem(action.payload);
      state.cart = cart.toJson(false);
    },
    removeCartItem: (state, action: PayloadAction<CartItem>) => {
      const cart = Cart.fromJson(state.cart);
      cart.removeItem(action.payload);
      state.cart = cart.toJson(false);
    },
    toggleCartItem: (state, action: PayloadAction<CartItem>) => {
      const cart = Cart.fromJson(state.cart);
      cart.toggleItem(action.payload);
      state.cart = cart.toJson(false);
    },
  },
});

export const {
  setCurrency,
  setBillingInterval,
  setCartItems,
  addCartItem,
  removeCartItem,
  toggleCartItem,
} = cartSlice.actions;

export const selectCurrency = (state: RootState) => state.cart.currency;
export const selectBillingInterval = (state: RootState) =>
  state.cart.billingInterval;
export const selectCartItems = (state: RootState) =>
  state.cart.cart.items;
export const selectCart = (state: RootState) => Cart.fromJson(state.cart.cart);

export default cartSlice.reducer;
